import { IconButton, Separator } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FilterOperatorSelectField } from "./FilterOperatorSelectField";
import { FilterItem, FilterOperator } from "./filterTypes";
import { FilterValueField } from "./FilterValueField";

const Divider = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: max-content;
	align-items: center;
`;

const Line = styled(Separator)`
	height: 1px;
	grid-area: 1 / 1;
`;

const TextWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	grid-area: 1 / 1;
`;

const Text = styled.div`
	padding: 0 ${({ theme }) => theme.spacing(2)};
	background-color: white;
	color: ${({ theme }) => theme.colors.palette.grey[70]};
`;

const NameRow = styled.div`
	font-weight: bold;
	align-items: center;
	display: grid;
	grid-template-columns: 1fr max-content;
	gap: ${({ theme }) => theme.spacing(4)};
	margin: ${({ theme }) => theme.spacing(2)} 0;
`;

const OperatorWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 2fr;
	gap: ${({ theme }) => theme.spacing(4)};
`;

interface Props {
	namePrefix: string;
	filterItem: FilterItem;
	withDivider: boolean;
	onDelete: () => void;
}

export const FilterItemFields: FC<Props> = ({ filterItem, withDivider, onDelete, namePrefix }) => {
	const { t } = useTranslation();
	const deleteTitle = t("Remove filter entry");
	const [{ value }] = useField<FilterOperator | null>(`${namePrefix}.operator`);

	return (
		<>
			<NameRow>
				<span>{t(`${filterItem.entity}.${filterItem.field}`)}</span>
				<IconButton type="button" title={deleteTitle} size="small" onClick={onDelete} icon="delete" />
			</NameRow>
			<OperatorWrapper>
				<FilterOperatorSelectField name={namePrefix} options={filterItem.operators} />
				{value && (
					<FilterValueField
						name={`${namePrefix}.value`}
						operator={value}
						entity={filterItem.entity}
						field={filterItem.field}
					/>
				)}
			</OperatorWrapper>
			{withDivider && (
				<Divider>
					<Line />
					<TextWrapper>
						<Text>{t("AND")}</Text>
					</TextWrapper>
				</Divider>
			)}
		</>
	);
};
